import React from "react";
import { Info } from "lucide-react";

/**
 * Banner for screens that still render built-in prototype figures instead of
 * the customer's own data. Remove it from a page once the page reads the API.
 */
const SampleDataNotice = ({ what }) => (
  <div
    role="note"
    className="flex items-start gap-2 rounded-md border border-s360-warning bg-s360-warning-bg px-3 py-2 text-[13px] text-s360-warning-ink"
  >
    <Info className="w-4 h-4 mt-0.5 shrink-0" aria-hidden="true" />
    <span>
      <strong className="font-semibold">Sample data.</strong> The {what} shown here are
      illustrative examples, not your orders. Live {what} are not connected yet.
    </span>
  </div>
);

export default SampleDataNotice;
